import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import routes from "@/routes";
import ScrollToTop from "@/utils/ScrollToTop";
const LoadingFallback = () => (_jsx("div", { className: "flex min-h-screen items-center justify-center bg-white", children: _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-streetlawyer-gold-400 border-r-transparent" }), _jsx("p", { className: "mt-4 text-streetlawyer-charcoal-600", children: "Loading\u2026" })] }) }));
const App = () => {
    const routing = useRoutes(routes);
    return (_jsxs(_Fragment, { children: [_jsx(ScrollToTop, {}), _jsx(Suspense, { fallback: _jsx(LoadingFallback, {}), children: routing })] }));
};
export default App;
